import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { dateformat } from 'src/app/models/commonModel';
import { CommonService } from 'src/app/services/common/common.service';
import { SessionPassDialogComponent } from '../session-pass-dialog/session-pass-dialog.component';
import { SessionDetailDialogComponent } from '../session-detail-dialog/session-detail-dialog.component';

@Component({
    selector: 'app-view-more-session-dialog',
    templateUrl: './view-more-session-dialog.component.html',
    styleUrls: ['./view-more-session-dialog.component.scss'],
    standalone: false
})
export class ViewMoreSessionDialogComponent implements OnInit {

  // Common properties
  sessionDay: any;
  sessionList: any = [];
  customerId: any;
  searchString = '';
  pageNumber: any = 1;
  pageSize: any = 10;
  @ViewChild(MatPaginator) paginator: any;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  currentPage: number = 0;
  totalrecord: number = 0;
  sortColumn: string = '';
  sortOrder: string = '';
  dateFormat: any;
  isSessionAvailable: boolean = true;

  constructor(
    private dialogRef: MatDialogRef<ViewMoreSessionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private api: ApiUrlHelper,
    private dialog: MatDialog,
    public datePipe: DatePipe) {
    this.sessionDay = data.sessionDay;
    this.customerId = data.customerId;
  }

  ngOnInit(): void {
    this.getUpcomingSessionListByDay();
    this.dateFormat = dateformat
  }

  cancel() {
    this.dialogRef.close(false);
  }

  getUpcomingSessionListByDay() {
    this.isSessionAvailable = true;
    let api = this.api.apiUrl.Class.GetUpcomingSessionForViewMore;
    let requestModel = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      SortColumn: "",
      SortOrder: "",
      StrSearch: this.searchString,
      UserId: 0,
      CustomerId: this.customerId,
      Day: this.sessionDay,
      StartDateTime: this.formatDate(new Date())
    };
    this.spinner.show();
    this.commonService.doPost(api, requestModel).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          if (this.searchString == '' && response.data.length == 0) {
            this.isSessionAvailable = false
          }
          this.totalrecord = response.data[0]?.totalRecords
          this.sessionList = response.data;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
      }
    });
  }

  formatDate(Date: Date): string {
    const date = this.datePipe.transform(Date, 'yyyy-MM-dd');
    const time = this.datePipe.transform(Date, 'HH:mm:ss.SSS',);
    return date + 'T' + time;
  }

  // Page Change Event happen
  pageChanged(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getUpcomingSessionListByDay();
  }

  //For Sort Data event happen
  sortData(event: any) {
    this.sortOrder = event.direction;
    this.sortColumn = event.active;
    this.getUpcomingSessionListByDay();
  }

  applyFilter(event) {
    if ((event.target.value == '') || (event.key && event.key === "Enter" && event.target.value != '')) {
      this.getUpcomingSessionListByDay();
    }
  }

  clearSearch() {
    this.searchString = '';
    this.getUpcomingSessionListByDay();
  }

  viewDescription(description: any) {
    const dialogRef = this.dialog.open(SessionDetailDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        description: description,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
    })
  }

  addPass(sessionId: any) {
    const dialogRef = this.dialog.open(SessionPassDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        customerId: this.customerId,
        classSessionData: sessionId
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogRef.close(result);
    });
  }
}